import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { House, Path, Garage, SlidersHorizontal, ShoppingCart, DotsThreeOutline, Users, Trophy, Bank, Wallet, X } from '@phosphor-icons/react';

const navItems = [
    { path: '/dashboard', icon: House, label: 'Home' },
    { path: '/ride', icon: Path, label: 'Ride' },
    { path: '/garage', icon: Garage, label: 'Garage' },
    { path: '/controller', icon: SlidersHorizontal, label: 'Tune' },
    { path: '/shop', icon: ShoppingCart, label: 'Shop' },
];

const moreItems = [
    { path: '/community', icon: Users, label: 'Feed' },
    { path: '/challenges', icon: Trophy, label: 'Quests' },
    { path: '/governance', icon: Bank, label: 'DAO' },
    { path: '/wallet', icon: Wallet, label: 'Wallet' },
];

export default function BottomNav() {
    const location = useLocation();
    const [moreOpen, setMoreOpen] = useState(false);

    const isPathActive = (path) => location.pathname === path ||
        (path === '/shop' && location.pathname.startsWith('/shop'));

    const moreActive = moreItems.some((i) => isPathActive(i.path));

    const renderItem = ({ path, icon: Icon, label }, onClick) => {
        const isActive = isPathActive(path);
        return (
            <Link
                key={path}
                to={path}
                onClick={onClick}
                className={`bottom-nav-item relative ${isActive ? 'active' : ''}`}
                data-testid={`nav-${label.toLowerCase()}`}
            >
                <div className={`p-2 rounded-lg transition-all duration-300 ${
                    isActive ? 'bg-primary/10 shadow-[0_0_12px_rgba(30,144,255,0.3)]' : ''
                }`}>
                    <Icon size={22} weight={isActive ? 'fill' : 'regular'} />
                </div>
                <span className="text-[10px] mt-0.5 tracking-wider uppercase" style={{ fontFamily: 'var(--font-display)' }}>
                    {label}
                </span>
            </Link>
        );
    };

    return (
        <>
            {moreOpen && (
                <div className="fixed inset-0 z-40 bg-black/70 backdrop-blur-sm md:hidden" onClick={() => setMoreOpen(false)} data-testid="bottom-nav-more-overlay">
                    <div className="absolute bottom-16 left-0 right-0 p-4 rounded-t-2xl bg-[#0b0b0f] border-t border-white/10" onClick={(e) => e.stopPropagation()} data-testid="bottom-nav-more-sheet">
                        <div className="flex justify-between items-center mb-3">
                            <span className="text-[11px] tracking-wider uppercase opacity-60" style={{ fontFamily: 'var(--font-display)' }}>More</span>
                            <button type="button" onClick={() => setMoreOpen(false)} aria-label="Close"><X size={18} /></button>
                        </div>
                        <div className="grid grid-cols-4 gap-2 text-center">
                            {moreItems.map((item) => renderItem(item, () => setMoreOpen(false)))}
                        </div>
                    </div>
                </div>
            )}
            <nav className="bottom-nav md:hidden" data-testid="bottom-navigation">
                <div className="flex justify-around items-center max-w-lg mx-auto h-16">
                    {navItems.map((item) => renderItem(item))}
                    <button
                        type="button"
                        onClick={() => setMoreOpen((v) => !v)}
                        className={`bottom-nav-item relative ${moreActive || moreOpen ? 'active' : ''}`}
                        data-testid="nav-more"
                    >
                        <div className={`p-2 rounded-lg transition-all duration-300 ${
                            moreActive || moreOpen ? 'bg-primary/10 shadow-[0_0_12px_rgba(30,144,255,0.3)]' : ''
                        }`}>
                            <DotsThreeOutline size={22} weight={moreActive || moreOpen ? 'fill' : 'regular'} />
                        </div>
                        <span className="text-[10px] mt-0.5 tracking-wider uppercase" style={{ fontFamily: 'var(--font-display)' }}>
                            More
                        </span>
                    </button>
                </div>
            </nav>
        </>
    );
}
